<template>
    <v-app pb-3>
        <v-content>
            <v-container grid-list-lg style="max-width: 1240px" class="py-0">
                <v-layout pb-3>
                    <v-flex>
                        <a class="policy" href="/kbm-list">Список запросов</a>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex pb-4 pt-4>
                        <h1>Проверка и восстановление КБМ</h1>
                    </v-flex>
                </v-layout>
                <kbm-free-recoveries v-if="!isAdmin"
                    :free-recoveries="freeRecoveries"
                    :policies-sold="policiesSold"
                />

                <v-form ref="form" v-model="valid" pt-4>
                    <v-layout row wrap align-end>
                        <v-flex xs12 sm6 md4 py-0>
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="hasOldLastName"
                                :label="'Менялась фамилия'"
                                :disabled="step > 2"
                            />
                            <osago-name
                                v-model="lastName"
                                label="Фамилия"
                                :isDisabled="step > 2"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md4 py-0 style="align-self: flex-end"
                                v-if="hasOldLastName"
                        >
                            <osago-name
                                v-model="oldLastName"
                                label="Старая фамилия"
                                :isDisabled="step > 2"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md4 py-0>
                            <osago-name
                                v-model="firstName"
                                label="Имя"
                                :isDisabled="step > 2"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md4 py-0>
                            <osago-name
                                v-model="middleName"
                                label="Отчество"
                                optional="true"
                                genitiveLabel="отчества"
                                :isDisabled="step > 2"
                                :noField.sync="noMiddleName"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md4 py-0
                                style="align-self: flex-end"
                        >
                            <osago-date
                                v-model="birthday"
                                :max="maxBirthdate"
                                label="Дата рождения"
                                :isDisabled="step > 2"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md4 py-0>
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="hasOld"
                                :label="'Есть старые права'"
                                :disabled="step > 2"
                            />
                            <v-text-field
                                v-model="license"
                                :label="(hasOld ? 'Новые права' : 'Права') + ': серия и номер'"
                                :rules="[rules.required,rules.license]"
                                :disabled="step > 2"
                                @paste="removeSpacesOnPaste($event, license)"
                                mask="##SS ######"
                                return-masked-value
                                validate-on-blur
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md4 py-0 style="align-self: flex-end"
                                v-if="hasOld"
                        >
                            <v-text-field
                                v-model="oldLicense"
                                label="Старые права: серия и номер"
                                :rules="[rules.required,rules.license,noEquilSeriesNumber]"
                                :disabled="step > 2"
                                @paste="removeSpacesOnPaste($event, oldLicense)"
                                mask="##SS ######"
                                return-masked-value
                                validate-on-blur
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md4 py-0>
                            <osago-date
                                v-model="kbmdate"
                                :max="today"
                                :isDisabled="step > 2"
                                label="Дата запроса"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout pt-4 row wrap>
                        <v-flex xs12 sm6>
                            <v-btn @click="validate(submitHistory)"
                                   :loading="wait"
                                   :disabled="step > 2"
                                   class="submit-button block">Проверить КБМ</v-btn>
                        </v-flex>
                    </v-layout>

                    <div v-if="step > 1">
                        <div v-if="historyLength > 0">
                            <v-data-table
                                pt-4
                                :headers="tableHeaders"
                                :items="tableItems"
                                hide-actions
                                no-data-text="Нет данных"
                                no-results-text="Ничего не найдено"
                            >
                                <template v-slot:items="props">
                                    <tr class="text-align-center">
                                        <td>{{ props.item.date }}</td>
                                        <td>{{ props.item.kbm }}</td>
                                        <td>{{ props.item.class }}</td>
                                        <td>{{ props.item.losses }}</td>
                                        <td>
                                            <a class="policy" @click="downloadReport(props.item.link)" target="_blank">Скачать</a>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:headers="props">
                                    <tr>
                                        <th
                                            v-for="header in props.headers"
                                            :key="header.text"
                                            :class="'column'"
                                        >
                                            {{ header.text }}
                                            <img v-if="header.value === 'link'" class="tip-icon" src="/svg/q.svg" alt=""
                                                 data-tippy-animateFill="false"
                                                 data-tippy-animation="scale"
                                                 data-tippy-content="Если срок хранения файла истёк - просто проверьте КБМ ещё раз!"
                                            />
                                        </th>
                                    </tr>
                                </template>
                            </v-data-table>
                        </div>

                        <v-layout v-if="historyLength === 0" pt-4 row wrap>
                            <v-flex>
                                <h4>Информация не найдена</h4>
                            </v-flex>
                        </v-layout>

                        <v-layout pt-4 row wrap>
                            <v-flex pt-4>
                                <h3>Внимание! Восстановление КБМ может занимать от 12 часов до 7 дней.</h3>
                            </v-flex>
                        </v-layout>

                        <kbm-free-recoveries v-if="!isAdmin && !freeRecoveries"
                                             :free-recoveries="freeRecoveries"
                                             :policies-sold="policiesSold"
                        />

                        <v-layout pt-4 row wrap>
                            <v-flex xs12>
                                <file-upload-field
                                    :validation="imageValidation"
                                    @getImg="getImg"
                                    @removeImg="removeImg"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <div class="policy-wrapper">
                                    Отправляя анкету, соглашаюсь
                                    <br>с <a class="policy" target="_blank" href="https://getpolis.ru/osago_policy">политикой
                                    обработки персональных данных</a>
                                    <br>и даю 
                                        <a class="policy" target="_blank" href="https://getpolis.ru/soglasie_pdn">
                                    Согласие на обработку персональных данных
                                        </a>
                                </div>
                            </v-flex>
                            <v-flex xs12 sm6 md4 lg3>
                                <v-btn v-if="step > 2"
                                    class="submit-button block v-btn--disabled">Восстановить КБМ</v-btn>
                                <v-btn v-else-if="isAdmin || freeRecoveries"
                                    @click="validate(submitRecovery)"
                                    :loading="wait"
                                    class="submit-button block">Восстановить КБМ бесплатно</v-btn>
                                <v-btn v-else
                                    @click="validate(submitRecoveryPayment)"
                                    :loading="wait"
                                    class="submit-button block">Восстановить КБМ за {{ this.recoveryPrice }}₽</v-btn>
                            </v-flex>
                            <v-flex xs12 sm6 md4 lg3
                                    v-if="hasBalance && step < 3"
                            >
                                <v-btn @click="validate(submitRecoveryPaymentFromBalance)"
                                       :loading="wait"
                                       class="submit-button block">Восстановить КБМ за {{ this.recoveryPrice }}₽ с баланса</v-btn>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-form>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import _ from 'lodash';
import helperMixin from '../../mixins/helper';

export default {
    name: 'KbmCheckAndRecovery',
    mixins: [helperMixin],
    props: {
        isAdmin: {
            default: false
        },
        params: {
            default: null
        },
        recoveryPrice: {
            default: 150
        }
    },
    data: () => ({
        uuid: '',
        noEquilSeriesNumber: true,
        wait: false,
        valid: false,

        step: 1,
        firstName: '',
        lastName: '',
        oldLastName: '',
        hasOldLastName: false,
        middleName: '',
        noMiddleName: false,
        birthday: '',
        license: '',
        oldLicense: '',
        hasOld: false,
        kbmdate: '',

        today: '',
        maxBirthdate: '',
        history: [],
        tableHeaders: [
            {
                text: 'Дата',
                align: 'center',
                sortable: false,
                value: 'date'
            },
            {
                text: 'КБМ',
                align: 'center',
                sortable: false,
                value: 'kbm'
            },
            {
                text: 'Класс КБМ',
                align: 'center',
                sortable: false,
                value: 'class'
            },
            {
                text: 'Страховые случаи',
                align: 'center',
                sortable: false,
                value: 'losses'
            },
            {
                text: 'Файл доступен 5 мин.',
                align: 'center',
                sortable: false,
                value: 'link'
            },
        ],
        tableItems: [],
        freeRecoveries: 0,
        policiesSold: 0,
        image: null,
        imageValidation: true,
        hasBalance: false,
        rules: {
            required: v => !!v || 'Обязательное поле',
            license: v => /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) || 'Неверный формат',
            approvePrivacyPolicy: v => v || 'Необходимо согласиться с политикой обработки персональных данных'
        }
    }),
    mounted() {
        if (!this.params) {
            return;
        }
        const params = JSON.parse(window.atob(this.params));
        if (params.uuid) {
            this.uuid = params.uuid;
        }
        this.today = params.today;
        this.maxBirthdate = params.maxBirthdate;

        this.firstName = params.firstName ? params.firstName : '';
        this.lastName = params.lastName ? params.lastName : '';
        if (params.oldLastName) {
            this.oldLastName = params.oldLastName;
            this.hasOldLastName = true;
        }
        this.middleName = params.middleName ? params.middleName : '';
        this.noMiddleName = params.noMiddleName ? params.noMiddleName : false;
        this.birthday = params.birthday ? params.birthday : '';
        this.license = params.license ? params.license : '';
        if (params.oldLicense) {
            this.oldLicense = params.oldLicense;
            this.hasOld = true;
        }
        this.kbmdate = params.kbmdate ? params.kbmdate : this.today;
        if (params.history) {
            this.history = params.history;
            this.prepareHistory(this.history);
            this.step = 2;
        }
        this.freeRecoveries = params.freeRecoveries;
        this.policiesSold = params.policiesSold;
        this.hasBalance = params.hasBalance;
        if (params.status > 1) {
            this.step = 3;
        }
    },

    updated: () => {
        window.tippy.default('.tip-icon');
    },

    computed: {
        historyLength() {
            return this.history ? this.history.length : 0;
        }
    },

    methods: {
        inputOldLicenseNumber(event, license) {
            this.noEquilSeriesNumber = event == license ? 'Не может совпадать с номером новых прав' : true;
        },

        validate(successFunc) {
            if (this.$refs.form.validate()) {
                this.firstName = this.firstName ? this.firstName.trim() : '';
                this.lastName = this.lastName ? this.lastName.trim() : '';
                this.middleName = this.middleName ? this.middleName.trim() : '';
                this.oldLastName = this.oldLastName ? this.oldLastName.trim() : '';
                successFunc();
            } else {
                this.$nextTick(function () {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
            }
        },

        submitHistory() {
            this.wait = true;
            axios.post('/kbm-history', this.prepareData())
                .then(response => {
                    if (response.data) {
                        if (response.data.status === 'success') {
                            if (response.data.uuid) {
                                this.uuid = response.data.uuid;
                                window.history.pushState(null, null, '/kbm/' + this.uuid);
                            }
                            this.history = response.data.data;
                            this.prepareHistory(this.history);
                            this.step = 2;
                        } else {
                            if (response.data.uuid) {
                                this.uuid = response.data.uuid;
                                window.history.pushState(null, null, '/kbm/' + this.uuid);
                            }
                            this.step = 3;
                        }
                    } else {
                        console.log(response);
                        PNotify.error('Не удалось получить данные по КБМ.');
                    }
                }).catch(error => {
                console.log(error);
                PNotify.error('Не удалось получить данные по КБМ.');
            }).finally(() => { this.wait = false; });
        },

        submitRecovery() {
            if (!this.uuid) {
                PNotify.error('Нельзя отправить несуществующую заявку.');
            }
            if (!this.validateImage()) {
                PNotify.error('Проверьте правильность выделенных полей.');
                this.goToFirstError();
            }

            this.wait = true;
            axios.post('/kbm-recovery/' + this.uuid, {
                image: this.image
            })
                .then(response => {
                    if (response.data && response.data.status === 'success') {
                        this.step = 3;
                        PNotify.info('Заявка на восстановление КБМ успешно отправлена.');
                    } else {
                        console.log(response);
                        PNotify.error('Не удалось отправить заявку на восстановление КБМ.');
                    }
                }).catch(error => {
                console.log(error);
                PNotify.error('Не удалось отправить заявку на восстановление КБМ.');
            }).finally(() => { this.wait = false; });
        },

        submitRecoveryPayment() {
            if (!this.uuid) {
                PNotify.error('Нельзя отправить несуществующую заявку.');
            }

            PNotify.info('Нужно оплатить, но вы не можете оплатить');
        },

        submitRecoveryPaymentFromBalance() {
            if (!this.uuid) {
                PNotify.error('Нельзя отправить несуществующую заявку.');
            }
            if (!this.validateImage()) {
                PNotify.error('Проверьте правильность выделенных полей.');
                this.goToFirstError();
            }

            this.wait = true;
            axios.post('/kbm-recovery-balance/' + this.uuid, {
                image: this.image
            })
                .then(response => {
                    if (response.data && response.data.status === 'success') {
                        this.step = 3;
                        PNotify.info('Заявка на восстановление КБМ успешно отправлена.');
                    } else {
                        console.log(response);
                        PNotify.error('Не удалось отправить заявку на восстановление КБМ.');
                    }
                }).catch(error => {
                console.log(error);
                PNotify.error('Не удалось отправить заявку на восстановление КБМ.');
            }).finally(() => { this.wait = false; });
        },

        downloadReport(link) {
            axios.get('/kbm-report-download',
                {
                    params: {
                        link: link
                    },
                    responseType: 'arraybuffer',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const a = document.createElement('a');
                    a.href = url;
                    a.setAttribute('download', 'report.pdf');
                    document.body.appendChild(a);
                    a.click();
                })
                .catch(error => {
                    console.log(error);
                    PNotify.error('Не удалось скачать отчёт. Попробуйте запросить историю еще раз.')
                }
            );
        },

        prepareHistory(history) {
            let items = [];
            _.forEach(history, function(item) {
                let losses = 0;
                if (Array.isArray(item.lossCRTTypeList) && item.lossCRTTypeList.length) {
                    _.forEach(item.lossCRTTypeList, function(loss){
                        if (loss.policyNumberKey) {
                            losses++;
                        }
                    })
                }
                items.push({
                    date: item.datekbm,
                    kbm: item.kbmValue,
                    class: item.kbmClass,
                    losses: losses,
                    link: item.download
                });
            });
            this.tableItems = items;
        },

        prepareData() {
            return {
                uuid: this.uuid,
                firstName: this.firstName,
                lastName: this.lastName,
                middleName: this.middleName,
                noMiddleName: this.noMiddleName,
                birthday: this.birthday,
                license: this.license,
                oldLicense: this.hasOld ? this.oldLicense : '',
                kbmdate: this.kbmdate ? this.kbmdate : '',
                oldLastName: this.oldLastName ? this.oldLastName : ''
            }
        },

        goToFirstError() {
            this.$vuetify.goTo('.error--text', {
                duration: 600,
                offset: 150,
                easing: 'easeInCubic',
            });
        },

        getImg(data) {
            this.imageValidation = true
            this.image = data
        },

        removeImg() {
            this.image = null
        },

        validateImage() {
            if (!this.image) {
                this.imageValidation = false
                return false
            }
            this.imageValidation = true
            return true
        },
    }
}
</script>

<style scoped>
.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important ;

    height: 65px;
    width: 280px;
    background-color: #00ba57 !important;;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.submit-button >>> .v-btn__content {
    white-space: pre-wrap;
    padding: 0 50px;
    line-height: 1.1;
}

.text-align-center {
    text-align: center;
}

a.policy {
    color: #00ba57;
}

.policy-wrapper {
    text-align: left;
    display: table-cell;
    vertical-align: middle;
}

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

@media(max-width: 600px){
    /deep/ h1 {
        font-size: 40px;
    }
}

@media(max-width: 480px) {
    /deep/ h1 {
        font-size: 30px;
    }
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/kbm/KbmCheckAndRecovery.vue